import { useLocation } from 'react-router-dom';
import { useGlobal } from '../../state';
import { Button } from '../input';
import { docsUrl, headerHeight } from '../../constants';

export const LeftNav = ({ children }) => {
  const { apiKey } = useGlobal();
  const location = useLocation();

  const style = {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '8px 16px',
  };

  if (!apiKey) {
    return <div style={style}>{children}</div>;
  }

  const button = (path, text) => {
    const shared = {
      style,
      to: path,
    };
    if (location.pathname == path) {
      return (
        <Button grayFlat {...shared}>
          {text}
        </Button>
      );
    } else {
      return (
        <Button trans gray {...shared}>
          {text}
        </Button>
      );
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 20 }}>
      <div style={{ position: 'sticky', top: headerHeight + 10, width: 140 }}>
        {button('/new', 'New Job')}
        {button('/dashboard', 'Dashboard')}
        {button('/jobs', 'Jobs')}
        {button('/agents', 'Agents')}
        {/*button('/costs', 'Cost Explorer')*/}
        {button('/billing', 'Billing')}
        {/*button('/quick-start', 'Quick Start')*/}
        {button(docsUrl, 'Docs')}
      </div>
      <div style={{ flex: 1, minWidth: 0, marginRight: 10 }}>{children}</div>
    </div>
  );
};
